<template>
  <div class="v-logo">
    <span class="v-logo-title">大数据可视化配置系统</span>
    <span class="v-logo-version">1.0</span>
  </div>
</template>

<script>
export default {
  name: 'v-logo',
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.v-logo {
  color: $font-color-base;
  user-select: none;
  .v-logo-title {
    padding-left: 18px;
    font-size: 20px;
    letter-spacing: 2px;
    padding-right: 5px;
  }
  .v-logo-version {
    font-size: 12px;
  }
}
</style>